import * as React from 'react';
import { useRecordContext } from 'react-admin';

export interface ContextTitleProps {
  context: string;
}
const ContextTitle = (props: ContextTitleProps) => {
  const record = useRecordContext();
  return <span>{record ? record[props.context] : ''}</span>;
};

export default ContextTitle;
